<template>
  <div>
    <van-form ref="vanForm" colon>
      <van-field readonly clickable name="picker" class="taocan" :value="form.value" label="套餐名称" placeholder="点击选择套餐"
        @click="showPicker = true" input-align="right" />
      <van-field v-model="form.getPrice" label="套餐单价" input-align="right" readonly />
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        移动卡25张倍数起订,联通卡是10的倍数起订
      </van-notice-bar>
      <van-field class="shuliang" name="switch" label="常用数量">
        <template #input>
          <van-button native-type="button" plain hairline type="info" style="margin-right:20px" @click="sl('10')"
            v-if="!form.value||(form.value.indexOf('联通') > -1)">10张</van-button>
          <van-button native-type="button" plain hairline type="info" style="margin-right:20px" @click="sl('25')"
            v-if="!form.value||(form.value.indexOf('移动') > -1)">25张</van-button>
          <van-button native-type="button" plain hairline type="info" style="margin-right:20px"
            @click="sl('50')">50张</van-button>
          <van-button native-type="button" plain hairline type="info" style="margin-right:20px"
            @click="sl('100')">100张</van-button>
        </template>
      </van-field>
      <van-field class="jiajian" label="数量" readonly>
        <template #input>
          <div v-show="form.sl">
            <van-button size="mini" plain icon="minus" @click="changFormSLBtn('-')" type="info"></van-button>
            <div>{{ form.sl }}</div>
            <van-button size="mini" plain icon="plus" @click="changFormSLBtn('+')" type="info"></van-button>
          </div>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="button" @click="addOrder">加入购物车</van-button>
      </div>
      <van-divider content-position="left">购物车</van-divider>
      <purchasingMgVanCollapseContenty @delOrder=delOrder class="pag" :list="tableData">
      </purchasingMgVanCollapseContenty>
      <div class="yunfei">
        <van-field v-model="form.yf" name="yf" label="运费" readonly input-align="right" />
        <van-radio-group v-model="vanRadio" @change="changeCligk" direction="horizontal" icon-size="0.4rem">
          <van-radio :disabled='allPrice<50000 && !disabledFirst' name="01">满500顺丰包邮</van-radio>
          <van-radio :disabled='allPrice>=50000 && !disabledFirst' name="02">加8元顺丰陆运包邮</van-radio>
          <van-radio name="03">顺丰航空到付</van-radio>
        </van-radio-group>
      </div>
      <van-field class="shr" input-align="right" v-model="form.deliveryName" label="收货人名称" />
      <van-field class="shr" input-align="right" v-model="form.deliveryMobile" label="收货人电话" />
      <van-field class="shr" input-align="right" v-model="form.address" label="收货人地址" />
      <div class="footer"></div>
      <van-submit-bar :loading=submitLoading :price="allPrice" button-text="支付" @submit="payment" />
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="list" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script>
import purchasingMgVanCollapseContenty from '@/components/purchasingMgVanCollapseContenty'
// , PriceChangePK
import {
  purOnlinePK,
  userAdress,
  OnlinePurchasing
} from '@/api/orther.js'
import {
  payUnifiedOrder,
  payUnifiedOrderV2
} from '@/api/api.js'
import {
  initConfig,
  chooseWXPay
} from '@/api/wxShare.js'
import wx from 'weixin-js-sdk'

export default {
  components: {
    purchasingMgVanCollapseContenty
  },
  props: {},
  data () {
    return {
      checked: true,
      form: {
        pkName: '',
        getPrice: '',
        deliveryName: '',
        deliveryMobile: '',
        address: '',
        value: '',
        yf: '',
        sl: '',
        dj: ''
      },
      tableData: [],
      showPicker: false,
      newPriceMesage: '',
      list: [],
      // 总金额
      allPrice: 0,
      vanRadio: '02',
      submitForm: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        pkList: [],
        delivery: '',
        address: '',
        deliveryMobile: '',
        deliveryName: ''
      },
      orderId: '',
      submitLoading: false,
      czIndex: 0,
      disabledFirst: false,
      changFormSLBtnNum: 0
    }
  },
  watch: {},
  computed: {},
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    sl (e) {
      this.changFormSLBtnNum = e
      this.form.sl = e
    },
    addOrder () {
      // this.$toast.success('修改成功')
      if (!this.form.pkName) return this.$toast.fail('请先选择套餐')
      if (!this.form.sl) return this.$toast.fail('请先选择购买数量')
      let arr = 0
      this.tableData.forEach(item => {
        if (item.id === this.form.packageId) {
          item.sl = item.sl * 1 + this.form.sl * 1
          item.je = item.sl * item.dj
          arr++
        }
      })
      if (arr === 0) {
        this.tableData.push({
          pkName: this.form.pkName,
          sl: this.form.sl,
          dj: this.form.getPrice,
          je: this.form.sl * 10 * this.form.getPrice / 10,
          id: this.form.packageId
        })
      }
      this.getAllPrice()
    },
    changeCligk (e) {
      if (e === '01') {
        if (this.allPrice >= 50000) {
          this.form.yf = 0
        } else {
          this.vanRadio = ''
          return this.$toast.fail('包邮需满500元')
        }
      }
      switch (e) {
        case '02':
          this.form.yf = 8
          break
        case '03':
          this.form.yf = ''
          break
      }
      this.allPrice = 0
      this.tableData.forEach(item => {
        this.allPrice = this.allPrice * 1 + item.je * 1
      })
      if (this.form.yf !== 8) {
        this.allPrice = this.allPrice * 100
      } else {
        this.allPrice = (this.allPrice * 1 + this.form.yf * 1) * 100
      }
    },
    getAllPrice (e, index) {
      if (e === 'del') {
        this.tableData.splice(index, 1)
      }
      this.allPrice = 0
      this.tableData.forEach(item => {
        this.allPrice = this.allPrice * 1 + item.je * 1
      })
      if (this.allPrice >= 500) {
        this.vanRadio = '01'
        this.form.yf = 0
      } else {
        this.vanRadio = '02'
      }
      if (this.form.yf !== 8) {
        this.allPrice = this.allPrice * 100
      } else {
        this.allPrice = (this.allPrice * 1 + this.form.yf * 1) * 100
      }
    },
    changFormSLBtn (e) {
      if (e === '+') {
        this.form.sl = this.form.sl * 1 + this.changFormSLBtnNum * 1
      } else {
        if (this.form.sl * 1 - this.changFormSLBtnNum * 1 === 0) {
          return this.$toast('无法添加 0 张')
        }
        this.form.sl = this.form.sl * 1 - this.changFormSLBtnNum * 1
      }
    },
    // 获得上传订单的数据
    getPaymentForm () {
      this.submitForm.delivery = this.vanRadio
      this.submitForm.address = this.form.address
      this.submitForm.deliveryMobile = this.form.deliveryMobile
      this.submitForm.deliveryName = this.form.deliveryName
      let list = ''
      let lists = ''
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          list = item.id
          lists = item.sl
        } else {
          list += ',' + item.id
          lists += ',' + item.sl
        }
      })
      this.submitForm.packageIds = list
      this.submitForm.quantitys = lists
    },
    // 付款 上传订单
    async payment () {
      if (this.tableData.length === 0) return this.$toast.fail('请先选择采购物品')
      if (!this.vanRadio) return this.$toast.fail('请先选择运送方式')
      if (!this.form.deliveryName) return this.$toast.fail('请填写收货人名称')
      if (!this.form.deliveryMobile) return this.$toast.fail('请填写收货人电话')
      if (!this.form.address) return this.$toast.fail('请填写收货人地址')
      this.submitLoading = true
      this.getPaymentForm()
      const {
        data: res
      } = await OnlinePurchasing(this.submitForm)
      if (res.code === 1 && res.msg.indexOf('联通卡数量输入错误') !== -1) {
        this.$nextTick(_ => {
          this.submitLoading = false
        })
        return this.$toast.fail('联通卡数量输入错误')
      }
      if (res.code === 1 && res.msg.indexOf('移动卡数量输入错误') !== -1) {
        this.$nextTick(_ => {
          this.submitLoading = false
        })
        return this.$toast.fail('移动卡数量输入错误')
      }
      if (res.code === 1 && res.msg.indexOf('收件人手机号格式错误') !== -1) {
        this.$nextTick(_ => {
          this.submitLoading = false
        })
        return this.$toast.fail('收件人手机号格式错误')
      }
      if (res.code === 0 && res.msg.indexOf('余额支付成功') !== -1) {
        this.tableData = []
        this.allPrice = 0
        this.vanRadio = ''
        this.form.sl = ''
        this.form.dj = ''
        this.form.yf = ''
        this.form.getPrice = ''
        this.form.pkName = ''
        this.form.value = ''
        this.$nextTick(_ => {
          this.submitLoading = false
        })
        return this.$toast(res.msg)
      }
      this.orderId = res.extend.pay.id
      this.$store.commit('setOrder', this.orderId)
      this.payUnifiedOrderV2()
      // this.payUnifiedOrder()
    },
    // 付款V2:渠道支付
    async payUnifiedOrderV2 () {
      const {
        data: ress
      } = await payUnifiedOrderV2({
        payId: this.orderId,
        tradeType: 'JSAPI',
        openId: this.$store.state.openId
      })
      if (ress.code !== 0) {
        return this.$toast(ress.msg)
      }
      if (!ress.extend.payData) {
        return this.$toast('订单获取失败，请稍后重试')
      }
      const payData = ress.extend.payData
      if ('payUrl' in payData) {
        window.location.href = payData.payUrl
        return
      } else if (!payData.appId || !payData.nonceStr || !payData.packageValue || !payData.paySign || !payData.signType || !payData
        .timeStamp) {
        if (this.czIndex >= 0) {
          this.submitLoading = false
          return this.$toast('订单获取失败，请稍后重试')
        }
        this.czIndex++
        return this.payUnifiedOrderV2()
      }
      this.xfBtn(payData)
    },
    // 付款 微信支付
    async payUnifiedOrder () {
      const {
        data: ress
      } = await payUnifiedOrder({
        payId: this.orderId,
        tradeType: 'JSAPI',
        openId: this.$store.state.openId
      })
      if (!ress.appId || !ress.nonceStr || !ress.packageValue || !ress.paySign || !ress.signType || !ress
        .timeStamp) {
        if (this.czIndex > 4) {
          return this.$toast('订单获取失败，请稍后重试')
        }
        this.czIndex++
        return this.payUnifiedOrder()
      }
      this.xfBtn(ress)
    },
    // 付款 调起 支付
    xfBtn (ress) {
      const that = this
      chooseWXPay(ress.timeStamp, ress.nonceStr, ress.packageValue, ress.signType, ress.paySign, ress.appId).then(
        res => {
          // alert(res.errMsg)
          if (res.errMsg === 'chooseWXPay:ok') {
            // 调用查询商户接口
            this.submitLoading = false
            that.$store.commit('setFlag', 'true')
            that.$router.push({
              name: 'PayLoading'
            })
          }
        }).catch(err => {
        // alert(err.errMsg)
        this.submitLoading = false
        if (err.errMsg === 'chooseWXPay:cancel') return this.$toast('用户取消支付')
        if (err.errMsg === 'fail') return this.$toast('支付失败')
      })
    },
    // 选择套餐
    onConfirm (value) {
      if (!this.flag) {
        this.showPicker = false
        return
      }
      this.form.pkName = ''
      this.form.getPrice = ''
      this.form.yf = ''
      this.form.sl = ''
      this.form.dj = ''
      this.form.value = value.text
      this.form.packageId = value.value
      this.form.pkName = value.text
      this.form.getPrice = value.purchase
      this.showPicker = false
      // this.PriceChangePK()
      this.getconfig()
    },
    // 在线采购套餐
    async purOnlinePK () {
      const {
        data: res
      } = await purOnlinePK({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0]
      })
      if (res.code !== 1) {
        res.forEach(item => {
          this.list.push({
            text: item.pkName,
            value: String(item.packageId),
            purchase: item.purchase
          })
          this.flag = true
        })
        // console.log(this.list)
      } else {
        this.flag = false
      }
    },
    // 套餐价格查询
    // async PriceChangePK () {
    //   const { data: res } = await PriceChangePK({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], packageId: this.form.packageId })
    //   if (res.code !== 1) {
    //     this.form.getPrice = res.purchase
    //   }
    //   this.showPicker = false
    // },
    // 个人资料设置(显示)
    async myInfo () {
      const {
        data: res
      } = await userAdress({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0]
      })
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      this.form.deliveryName = res.deliveryName
      this.form.deliveryMobile = res.deliveryMobile
      this.form.address = res.address
      if (!res.address || !res.deliveryMobile || !res.deliveryName) {
        this.$toast.fail('请完善邮寄基本信息')
      }
    },
    delOrder (e) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否删除该商品'
      })
        .then(() => {
          // on confirm
          this.getAllPrice('del', e)
        })
        .catch(() => {
          // on cancel
        })
    },
    async getconfig () {
      const urlThis = location.href.split('#')[0]
      const {
        data: res
      } = await initConfig({
        url: urlThis
      })
      if (res) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          jsApiList: [
            'chooseWXPay'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      }
    }
  },
  beforeCreate () {},
  created () {
    this.purOnlinePK()
    this.myInfo()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .van-search {
    background-color: #eee;
  }

  .pag {
    margin-top: 20px;
  }

  .yunfei {
    /deep/.van-cell::after {
      border: none !important;
    }

    .van-radio-group {
      font-size: 24px !important;
      justify-content: center !important;

      .van-radio {
        margin-right: 15px;
      }
    }

    // border-bottom: 0.02667rem solid #ebedf0;
  }

  .taocan {
    /deep/.van-cell__value {
      flex: 4 !important;
    }
  }

  .shuliang {
    /deep/.van-button {
      margin: 0 !important;
      margin-left: 15px !important;
    }
  }

  /deep/.shr {
    .van-cell__title {
      flex: 1;
    }

    .van-cell__value {
      flex: 2;
    }
  }

  .footer {
    position: relative;
    height: 100px;
  }

  .van-form {
    position: relative;
  }

  /deep/.van-submit-bar {
    position: absolute;
  }

  .jiajian {
    /deep/.van-field__control {
      div {
        display: flex;
        width: 100%;
        justify-content: center;
      }
    }
  }
</style>
